import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
  selector: 'app-export-process-snack',
  standalone: true,
  imports: [MatIconModule, TranslocoModule],
  templateUrl: './export-process-snack.component.html',
  styleUrls: ['./export-process-snack.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExportProcessSnackComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { processOrchestratorId: string, processName?: string, messageKey?: string },
    private snackBarRef: MatSnackBarRef<ExportProcessSnackComponent>,
    private router: Router
  ) { }

  close() {
    this.snackBarRef.dismiss();
  }

  viewProgress() {
    this.snackBarRef.dismiss();
    this.router.navigate(['employer/deferred-processes', this.data.processOrchestratorId]);
  }
}